<template lang="pug">
  #app(ref="app")

    stage
    header-component
    menu-component(v-if="supported")
    router-view
    down-arrow(v-if="supported")
    landscape-warning(v-if="supported")

</template>

<script>

import gsap from 'gsap'
import { mapState, mapMutations } from 'vuex'
import ResizeService from 'src/services/ResizeService'
import HeaderComponent from '@/components/header'
//import Stage from '@/components/stage' 
import MenuComponent from '@/components/menu'
import DownArrow from '@/components/home/DownArrow'
import LandscapeWarning from '@/components/unsupported/LandscapeWarning'
import { MODAL_STATES, PATHS, LOAD } from 'src/config/app'
import Env from '@/config/env'

export default {

  name: 'app',

  components: {
    HeaderComponent,
    'stage' : () => import(/* webpackPrefetch: true, webpackChunkName: "stage" */ '@/components/stage'),
    MenuComponent,
    DownArrow,
    LandscapeWarning
  },

  computed: {
    ...mapState('browser', ['isMobile']),
    ...mapState('app', ['loading']),

    supported(){
      return (!Env.ie)
    }
  },

  beforeMount() {
    // listen to resize service and update the store with changes
    ResizeService.on(ResizeService.Events.RESIZE, this.resize)
    this.resize()
    document.onkeydown = this.onKeyDown;
  },

  mounted() {
    // RIGHT CLICK CONTEXT MENU
    // window.addEventListener('contextmenu', (e) => {
    //   e.preventDefault()
    // })

  },

  watch: {
    'loading.state'(val){}
  },

  methods: {

    ...mapMutations('browser', [
      'setDevice',
      'setScale',
      'setFontSize',
      'setDimensions'
    ]),

    ...mapMutations('app', [
      'setModalState'
    ]),

    resize() {
      // put these in the store so we don't need to manually
      // listen to ResizeService everytime we want to react to
      // device/scale/size changes
      this.setDevice(ResizeService.device)
      this.setScale(ResizeService.scale)
      this.setFontSize(ResizeService.fontSize)
      this.setDimensions({
        width: ResizeService.width,
        height: ResizeService.height,
      })
    },

    onKeyDown(e){
      if(this.modal_state !== MODAL_STATES.NONE && e.key === "Escape") {
        this.setModalState(MODAL_STATES.NONE);
        this.$router.replace(PATHS.HOME)
      }
    },

  },
}
</script>

<style lang="sass">
@import "src/styles/base.sass"

#app
  +full()
  overflow: hidden 

</style>
